import { MultiSelectDropDownOption } from '../types';

/**
 * Filters options by search term using "starts with" matching on both value and id.
 */
export const filterOptions = (
  options: MultiSelectDropDownOption[] | Record<string, MultiSelectDropDownOption[]>,
  searchTerm: string,
  isMapOptions: boolean,
) => {
  if (!searchTerm) return options;

  const term = searchTerm.toLowerCase();

  if (isMapOptions) {
    const filtered: Record<string, MultiSelectDropDownOption[]> = {};
    Object.entries(options as Record<string, MultiSelectDropDownOption[]>).forEach(
      ([group, items]) => {
        const matchedItems = items.filter(
          (option) =>
            option.value.toLowerCase().startsWith(term) || option.id.toLowerCase().startsWith(term),
        );
        if (matchedItems.length > 0) {
          filtered[group] = matchedItems;
        }
      },
    );
    return filtered;
  } else {
    return (options as MultiSelectDropDownOption[]).filter(
      (option) =>
        option.value.toLowerCase().startsWith(term) || option.id.toLowerCase().startsWith(term),
    );
  }
};

export const flattenOptions = (
  options: MultiSelectDropDownOption[] | Record<string, MultiSelectDropDownOption[]>,
  isMapOptions: boolean,
): MultiSelectDropDownOption[] => {
  if (isMapOptions) {
    return Object.values(options as Record<string, MultiSelectDropDownOption[]>).flat();
  }
  return options as MultiSelectDropDownOption[];
};
